import { z } from 'zod';
import { integerSchema } from '../../validation';
import { orderImageTypesSchema } from './order.image.model';

export const orderPODCopySettingSchema = z.enum(['pod_image', 'return_original_pod']);

export const allowedStatusRadiusSchema = z.object({
  /** the allowed radius in Meters to change the status to arrived at pickup */
  pickup: integerSchema,
  /** the allowed radius in Meters to change the status to arrived at drop off */
  dropoff: integerSchema,
});
export const orderSettingsImageSchema = z.object({
  /** type of proof at pickup */
  pickup: z.array(orderImageTypesSchema).default([]),

  /** type of proof at drop off */
  dropoff: z.array(orderImageTypesSchema),

  /** type of prof when starting the order */
  start: z.array(orderImageTypesSchema),
});
export type OrderSettingsImage = z.infer<typeof orderSettingsImageSchema>;

export const orderSettingsSchema = z.object({
  images: orderSettingsImageSchema,
  /** the proof of delivery settings
   *
   * if `return_original_pod`, then the driver/carrier must return the actual POD
   */
  podCopy: z.array(orderPODCopySettingSchema),
  /** the allowed radius in Meters to change the status to arrived at pickup/drop off */
  allowedStatusRadius: allowedStatusRadiusSchema,
  /** if `true`, then the `user` is using this order internally such as delivering his own items and want to use our system as a SaaS.
   *
   * For example, a carrier company can use our system to mange its fleet and orders.
   *
   * In this case we will not make a payment for the platform `hero`
   */
  isSaaS: z.boolean(),
});
